import { getController /* , postController */ } from '@/controllers/request';
import { MODULE, /* ACTION,  */ EVENTBUS_EVENTS } from '@/utils/constants';
import { eventBus } from '@/bus';
import router from '@/router/index';
import { mixin, errorMsg } from '@/utils/mixins';

export default {
  namespaced: true,
  state: {
    callsListData: {},
    fields: {},
    callsList: [],
    loading: false,
    tableTitleParams: null,
    requestSent: false,
    hasUnviewedCalls: false
  },
  mixins: [mixin, errorMsg],
  mutations: {
    setCallsListData(state, value) {
      state.callsListData = value;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setMetadata(state, metadata) {
      state.metadata = metadata;
    },
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setFields(state, data) {
      state.fields = { ...data };
    },
    setFieldParam(state, { variable, param, value }) {
      if (state[variable]) {
        state[variable][param] = value;
      }
    },
    setCustomPopupFields(state, data) {
      state.customPopupFields = data;
    }
  },
  actions: {
    async getMetadata({ commit, state }, id) {
      if (!state.requestSent) {
        try {
          commit('setParam', {
            name: 'requestSent',
            val: true
          });
          //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
          const loaderTimeout = setTimeout(() => {
            if (!response?.data) {
              commit('setParam', {
                name: 'loading',
                val: true
              });
              //если данных нет, ожидаем их получения каждые 500 мс
              //если они получены, отключаем роутер
              const checkData = setInterval(() => {
                if (response?.data) {
                  commit('setParam', {
                    name: 'loading',
                    val: false
                  });
                  clearInterval(checkData);
                }
              }, 500);
            }
            clearTimeout(loaderTimeout);
          }, 300);
          const response = await getController({
            params: {
              module: MODULE.OMS_CALLS,
              action: 'getCallsView',
              record: router?.history?.current?.fullPath?.includes('calls')
                ? router?.history?.current?.params?.id || id
                : id
            }
          });
          commit('setParam', {
            name: 'requestSent',
            val: false
          });
          commit('setMetadata', response.data);

          if (response.data?.bean?.id.value) {
            return true;
          } else {
            if (response.data?.status == 'error') {
              errorMsg.methods.showNotification({
                offset: 100,
                showClose: true,
                message: response.data?.error?.error_text?.error || 'Ошибка',
                duration: 6500,
                type: 'error'
              });
            }
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
      }
    },
    async loadCalls({ commit, rootState }, { vacancyId = null }) {
      commit('setLoading', true);
      if (!vacancyId) {
        commit(
          'selectionPopup/setBaseParams',
          {
            module: MODULE.OMS_CALLS,
            action: 'ListView',
            jsqon_return: 1,
            to_pdf: true
          },
          { root: true }
        );
      }

      let filters = {};
      let currentFilters = rootState.filters.filterConfig.filters;
      let dataSortParams = rootState.filters.filterConfig.sortable;

      for (let key in currentFilters) {
        if (currentFilters[key].value != null) {
          filters[key] = currentFilters[key].value;
        }
      }

      let params = {
        module: MODULE.OMS_CALLS,
        displayMode: 'spa',
        action: 'ListView',
        OMS_CALLS2_OMS_CALLS_offset: 0,
        ...filters
      };

      if (rootState.filters.query) {
        params.query = true;
        commit(
          'filters/setParam',
          {
            name: 'query',
            val: false
          },
          { root: true }
        );
      }

      if (dataSortParams?.orderBy) {
        params['orderBy'] = dataSortParams.orderBy;
      }
      if (dataSortParams?.sortOrder) {
        params['sortOrder'] = dataSortParams.sortOrder;
      }

      if (vacancyId) {
        params['vacancy_id'] = vacancyId;
      }

      try {
        const request = await getController({ params });
        commit(
          'common/setTableData',
          {
            module: MODULE.OMS_CALLS,
            columns: request.data.data.data.data.title,
            rows: request.data.data.data.data.rows
          },
          { root: true }
        );

        commit('selectionPopup/setMetadataFields', request.data.sugarconfig, {
          root: true
        });

        commit(
          'common/setParam',
          {
            name: 'tableFields',
            val: request?.data?.sugarconfig
          },
          {
            root: true
          }
        );

        commit('selectionPopup/popupPageConfig', request.data.data.pageData, {
          root: true
        });

        commit('filters/setFiltersConfig', request.data.custom_search, {
          root: true
        });

        commit(
          'filters/setParam',
          {
            name: 'sortActive',
            val: !request.data?.custom_search?.sortable?.default || false
          },
          { root: true }
        );

        if (!vacancyId) commit('setCallsListData', request.data);

        if (request.data.data.data.data?.title_params) {
          commit('setParam', {
            name: 'tableTitleParams',
            val: request.data.data.data.data.title_params
          });
        }

        eventBus.$emit(EVENTBUS_EVENTS.UPDATE_TABLE);
      } catch (error) {
        console.error(error);
        commit('setCallsListData', {
          error:
            'У Вас нет доступа к данной странице. Свяжитесь с вашим системным администратором для получения соответствующих прав.'
        });
      } finally {
        commit('setLoading', false);
      }
    },
    async checkForUnviewedCalls({ state }) {
      const response = await getController({
        params: {
          module: MODULE.OMS_CALLS,
          action: 'check_unviewed_calls',
          to_pdf: '1'
        }
      });
      state.hasUnviewedCalls = response?.data?.unviewed;
    }
  }
};
